// extracted by mini-css-extract-plugin
export var askAiIcon = "_in-9";
export var container = "_in-0";
export var groupSeparator = "_in-a";
export var highlight = "_in-4";
export var resultIcon = "_in-5";
export var resultItem = "_in-7";
export var resultSubtitle = "_in-3";
export var resultTitle = "_in-2";
export var resultsList = "_in-1";
export var searchGroup = "_in-6";
export var selected = "_in-8";